export const StatCard = ({ icon: Icon, label, value }) => (
  <div className="rounded-2xl bg-white border border-[rgba(17,42,67,0.10)] p-5 shadow-[0_8px_24px_rgba(7,21,36,0.05)]">
    <div className="flex items-center gap-3">
      <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl" style={{ background: "rgba(18,111,106,0.10)", color: "#126F6A" }}>
        <Icon size={20} />
      </span>
      <div>
        <div className="text-2xl font-bold text-[#122131]">{value}</div>
        <div className="text-sm text-[#647384]">{label}</div>
      </div>
    </div>
  </div>
);

export const TrafficStat = ({ icon: Icon, label, value }) => (
  <div className="bg-white p-4">
    <div className="flex items-center gap-2 text-[#647384]">
      <Icon size={16} className="text-[#126F6A]" />
      <span className="text-xs font-medium uppercase tracking-wide">{label}</span>
    </div>
    <div className="mt-1 text-2xl font-bold text-[#122131]">{value}</div>
  </div>
);

// Shared confirm-button styling for destructive dashboard actions.
export const DANGER_BUTTON_CLASS =
  "inline-flex items-center gap-2 h-10 px-4 rounded-xl border border-[rgba(192,57,43,0.35)] bg-white text-[#c0392b] text-sm font-semibold hover:bg-[#fdecea] transition-colors disabled:opacity-50 disabled:cursor-not-allowed";
